/**
 * Formats a phone number from E.164 format (+19253033344) to US format (925)303-3344
 * @param phoneNumber - Phone number in E.164 format (e.g., "+19253033344")
 * @returns Formatted phone number as (XXX)XXX-XXXX or original string if invalid
 */
export function formatE164ToUSFormat(phoneNumber: string): string {
  // Remove any whitespace and validate basic format
  const cleaned = phoneNumber.trim()

  // Check if it's a valid E.164 format for US numbers (+1 followed by 10 digits)
  const e164Regex = /^\+1(\d{10})$/
  const match = cleaned.match(e164Regex)

  if (!match) {
    // Return original string if not valid E.164 US format
    return phoneNumber
  }

  const digits = match[1] // Extract the 10 digits after +1

  // Format as (XXX)XXX-XXXX
  const areaCode = digits?.slice(0, 3)
  const exchange = digits?.slice(3, 6)
  const number = digits?.slice(6, 10)

  return `(${areaCode})${exchange}-${number}`
}
